import { faCalendarCheck } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faLocation } from '@fortawesome/pro-solid-svg-icons/faLocation';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import { faStamp } from '@fortawesome/pro-solid-svg-icons/faStamp';
import { ContentBlock, FlexJustify, StackHorizontal, Surface, useTranslation } from '@ukpostbox/frontend-framework';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function SentInfo() {
	const { t } = useTranslation();
	const { mailItemData } = useMailbox();
	const { currentLocale } = useSite();

	return (
		<div className='mt-lg'>
			<h6 className='pageantry-sub-heading text-left'>{t('mailItem.labels.sendDetails')}</h6>
			<Surface>
				<StackHorizontal justify={FlexJustify.Between} fill>
					<ContentBlock
						iconContent={{ icon: faLocationDot, iconSize: '2x' }}
						title={t('mailItem.labels.address')}
						content={mailItemData?.forwardAddressId}
					/>
					<ContentBlock
						iconContent={{ icon: faStamp, iconSize: '2x' }}
						title={t('mailItem.labels.postage')}
						content={mailItemData?.postageOptionId}
					/>
					{mailItemData?.dateUpdated && (
						<ContentBlock
							iconContent={{ icon: faCalendarCheck, iconSize: '2x' }}
							title={t('mailItem.labels.dateProcessed')}
							content={FormatLocaleDateTime(mailItemData?.dateUpdated, currentLocale)}
						/>
					)}
					{mailItemData?.outgoingTrackingId && (
						<ContentBlock
							iconContent={{ icon: faLocation, iconSize: '2x' }}
							title={t('mailItem.labels.trackingId')}
							content={mailItemData?.outgoingTrackingId}
						/>
					)}
				</StackHorizontal>
			</Surface>
		</div>
	);
}

export { SentInfo };
